import router from '../router'
import store from '../store'
import { DELETE_TARGET } from '../views/audienceHub/store/actions'
import types from '@/appComponents/workbench/attributePanel/services/attributeType'
import { INTENTS, ACTIVATION_STATUS } from '../appLogic/targets/Constants'
const { SELECT, RANGE, RANGE_SELECT } = types

export function convertAttributeToDisplay (attr) {
  let result = null
  switch (attr.type) {
    case SELECT:
      result = attr.options ? attr.options.find(option => { return option.value === attr.value }).name : attr.value
      break
    case RANGE:
    case RANGE_SELECT:
      result = `${attr.value.min} - ${attr.value.max}`
      break
    default:
      result = typeof attr.value === 'string' ? attr.value : '-'
  }
  return result
}

export function createDisplayName (attr) {
  let name = ''
  if (attr.parent) {
    name = `${attr.parent} - `
  }
  const convertValue = convertAttributeToDisplay(attr)
  const extention = convertValue === '-' ? '' : ` - (${convertValue})`
  if (!attr.type) {
    return `${name}${attr.id}${extention}`
  }
  return `${name}${attr.name}${extention}`
}

export function definitionAsString (definition) {
  const reducer = (acc, attr) => {
    if (attr.type || attr.id && attr.value) {
      acc.push(createDisplayName(attr))
    }

    if (Array.isArray(attr)) {
      // add left bracket
      acc.push('(')
      // build group children
      acc.concat(attr.reduce(reducer, acc))
      // add right bracket
      acc.push(')')
    }

    if (typeof attr === 'string') {
      acc.push(attr)
    }

    return acc
  }
  return definition.reduce(reducer, [])
}

export function definitionAsHtml (definition) {
  let level = 1
  const colors = ['#a0a7ac', '#4da3c2', '#9e5fa8', '#4a3f57']

  const reducer = (acc, attr, index, arr) => {
    if (attr.type || attr.id && attr.value) {
      acc.push(`<span style="color: ${colors[level]};">`)
      acc.push(createDisplayName(attr))
      acc.push('</span>')
    }

    if (Array.isArray(attr)) {
      level++
      // add left bracket
      acc.push(`<span style="color: ${colors[level]}; font-weight: bold;">(</span>`)
      // build group children
      acc.concat(attr.reduce(reducer, acc))
      // add right bracket
      acc.push(`<span style="color: ${colors[level]}; font-weight: bold;">)</span>`)
      level--
    }

    if (typeof attr === 'string') {
      acc.push(`<span style="color: ${colors[level - 1]};"> `)
      if (level === 1) {
        acc.push('<br/>')
      }
      acc.push(attr === 'AND' ? '&' : attr)
      acc.push(' </span>')
    }

    return acc
  }
  return definition.reduce(reducer, []).join('')
}

export function definitionToListOfTraits (definition) {
  const reducer = (acc, attr, index, arr) => {
    if (attr.type || attr.id && attr.value) {
      acc.push(attr)
    }

    if (Array.isArray(attr)) {
      // build group children
      acc.concat(attr.reduce(reducer, acc))
    }

    return acc
  }
  return definition.reduce(reducer, [])
}

export function createNamespaceStripper (namespace) {
  return function (fullConst) {
    if (namespace.lastIndexOf('/') === -1) {
      namespace += '/'
    }
    return fullConst.replace(namespace, '')
  }
}

export function commaFormatString (string) {
  return Number(string).toLocaleString('en')
}

export function dateFormatter (date, utc = true) {
  const options = { year: 'numeric', month: 'short', day: 'numeric' }
  let d = new Date(date).toLocaleString('en-us', utc ? {...options, timeZone: 'UTC'} : options)
  return d
}

export function getUTCcorrectedDate (dateString) {
  let start = new Date(dateString)
  var offset = start.getTimezoneOffset()
  start.setTime(start.getTime() + (1000 * 60 * offset))
  return start
}

export function getUTCTimeNow () {
  return new Date(new Date().getTime() + new Date().getTimezoneOffset() * 1000 * 60)
}

export function yearMonthDateFormat (date) {
  return date.toISOString().split('T')[0]
}

export function titelizeString (str) {
  if (typeof str !== 'string') {
    return ''
  }
  var frags = str.split('_')
  for (let i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1)
  }
  return frags.join(' ')
}

export function isDecimal (num) {
  return num % 1 !== 0
}

// Currently you can only directly add a finite list of properties using this function. We can increase the list later if needed.
export function createTarget ({username, display_name, target, advertiser, target_datasource, target_definition, networks, viewing_stream}) {
  return {
    username,
    display_name,
    target,
    advertiser,
    target_datasource,
    target_definition,
    networks,
    viewing_stream
  }
}

export function isJsonString (str) {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export function targetCanBeActivated (target) {
  return (
    target.workbench_data.universe && target.workbench_data.viewership_historical && target.workbench_data.metrics
  )
}
export function SmTargetCanBeActivated (target) {
  return (
    target.workbench_data.metrics && target.workbench_data.audience_size && target.workbench_data.brand_reach && (target.workbench_data.target_definition || target.target_definition)
  )
}

export function lasActivationBlocked () {
  return false
}

export function smActivationBlocked () {
  return false
}

export function adActivationBlocked () {
  return true
}

export function isActivationBlocked (targetType) {
  return targetType === 'linear_ad_sales' ? lasActivationBlocked() : targetType === 'social_digital' ? smActivationBlocked() : targetType === 'audience_discovery' ? adActivationBlocked() : true
}

export const isTargetOwnedBy = (target, username) => target.username && (target.username.toLowerCase() === username.toLowerCase())

export const filterTargetOptions = (targetOptions, remove) => targetOptions.filter(t => remove.indexOf(t.name) === -1)

export const targetTypeToAbbrev = {
  'linear_ad_sales': 'las',
  'social_digital': 'sm',
  'audience_discovery': 'ad'
}

export function postDataEnabled () {
  return true
}

export function targetRouteHandler (action, target) {
  if (action === 'OPEN') {
    if (target.metadata.intents && target.metadata.intents.some(i => i['Name'] === INTENTS['Sales']['Name']) && target.activation_status === ACTIVATION_STATUS.WORKING) {
      router.push({ name: 'NewWorkbench', params: { id: target.id } })
    } else {
      router.push({ name: `${targetTypeToAbbrev[target.target]}-workbench`, params: { id: target.id } })
    }
  } else if (action === 'ACTIVATE') {
    router.push({ name: `${targetTypeToAbbrev[target.target]}-activate-target`, params: { target: target.target, id: target.id } })
  } else if (action === 'CONFIRM-ACTIVATION') {
    router.push({ name: `${targetTypeToAbbrev[target.target]}-confirm-activation`, params: { target: target.target, id: target.id } })
  } else if (action === 'DELETE') {
    store.dispatch(DELETE_TARGET, target)
  } else if (action === 'SETTINGS') {
    router.push({ name: `${targetTypeToAbbrev[target.target]}-edit-target`, params: { target: target.target, id: target.id } })
  } else if (action === 'DUPLICATE') {
    router.push({ name: `${targetTypeToAbbrev[target.target]}-duplicate-target`, params: { target: target.target, id: target.id } })
  }
}

export function downloadFile ({dataString, filename, format}) {
  const data = encodeURI(`data:${format};charset=utf-8,` + dataString)

  const link = document.createElement('a')
  link.setAttribute('href', data)
  link.setAttribute('download', filename)
  link.click()
}

export function convertArrayOfObjectsToCSV (args) {
  let data = args.data || null
  if (data == null || !data.length) {
    return null
  }

  const columnDelimiter = args.columnDelimiter || ','
  const lineDelimiter = args.lineDelimiter || '\n'

  const keys = args.keys || Object.keys(data[0])

  let result = ''
  result += keys.join(columnDelimiter)
  result += lineDelimiter

  data.forEach(function (item) {
    let ctr = 0
    keys.forEach(function (key) {
      if (ctr > 0) result += columnDelimiter

      let property = item[key].toString().replace(/"/g, '\\"')
      result += `"${property}"`
      ctr++
    })
    result += lineDelimiter
  })

  return result
}

export function delayPromise (t) {
  return new Promise(function (resolve) {
    setTimeout(resolve, t)
  })
}

export function formatNode ({parent, path, value, type, name}) {
  const leadString = (parent ? path + ' - ' : '')
  const booleanLeadString = (parent ? path + ': ' : '')
  if (type === 'range') {
    return leadString + name + ': ' + `(${value.min}-${value.max})`
  } else if (type === 'boolean') {
    return booleanLeadString + name
  } else if (type === 'select') {
    return leadString + name + ': ' + value
  }
}

export function formatQuery (query, lvl = 0) {
  let string = ''
  const spaces = '   '

  query.forEach(el => {
    if (typeof el === 'string') {
      string += '\n' + spaces.repeat(lvl) + el
    } else if (Array.isArray(el)) {
      string += '\n' + spaces.repeat(lvl) + '[' + '\n' + spaces.repeat(lvl + 1) + formatQuery(el, lvl + 1) + '\n' + spaces.repeat(lvl) + ']'
    } else {
      string += '\n' + spaces.repeat(lvl) + formatNode(el)
    }
  })

  return string.trim()
}

export function splitArrayIntoSizeN (arr, n) {
  let output = []
  let itr = 0

  while (itr < arr.length) {
    output.push(arr.slice(itr, itr + n))
    itr += n
  }

  return output
}

export const formatSmallMoney = (value) => {
  if (value.length <= 3) {
    return formatDollars(value)
  } else {
    const s = smallNumber(value)
    return '$' + s
  }
}

export const smallNumber = (value, decimalPlace = 0) => {
  value = String(Math.floor(Number(value)))
  value = value.split('.')[0]
  if (value.length <= 3) {
    return value
  } else {
    let length = value.length
    let s = ''
    let decimal = ''
    let suffix = ''
    if (length > 3 && length < 7) {
      let digits = length - 3
      s = value.substr(0, digits)
      suffix = 'T'
      decimal = value.substr(digits, decimalPlace)
    } else if (length > 6 && length < 10) {
      let digits = length - 6
      s = value.substr(0, digits)
      suffix = 'M'
      decimal = value.substr(digits, decimalPlace)
    }
    if (decimalPlace > 0) {
      return `${s}.${decimal} ${suffix}`
    }
    return `${s}${suffix}`
  }
}

export const newSmallNumber = function (value, decimalPlaces) {
  let currentPlace = 0
  let places = ['', 'K', 'M', 'B']
  let v = value
  while (v >= 1000) {
    v = v / 1000
    currentPlace += 1
  }
  let decimalPower = Math.pow(10, decimalPlaces)
  v = Math.round(v * decimalPower) / decimalPower
  if (v >= 1000) {
    currentPlace += 1
    v = v / 1000
  }
  return currentPlace > 0 ? `${v} ${places[currentPlace]}` : `${v}`
}

export const formatSmallNumber = (value) => {
  value = String(Math.floor(Number(value)))
  value = value.split('.')[0]
  let length = value.length
  let s = ''
  if (length > 3 && length < 7) {
    s = value.substr(0, length - 3) + ' K'
  } else if (length > 6 && length < 10) {
    s = value.substr(0, length - 6) + ' M'
  }
  return s
}

export const formatAndRoundSmallNumber = (value) => {
  value = String(Math.round(Number(value)))
  value = value.split('.')[0]
  let length = value.length
  let s = ''
  if (length > 3 && length < 7) {
    s = value.substr(0, length - 3) + ' K'
  } else if (length > 6 && length < 10) {
    s = value.substr(0, length - 6) + ' M'
  }
  return s
}

export const formatDollars = (value) => {
  if (value) {
    let negative = value < 0 ? '-' : ''
    let money = negative + '$' + formatCommas(value)
    return money
  } else {
    return ''
  }
}

export const formatCommas = (value) => {
  let numberString = String(Math.abs(value)).split('').reverse()
  let s = []
  for (let i in numberString) {
    let valid = Number(i) % 3 === 0 && Number(i) !== 0
    if (valid) {
      s.push(',')
    }
    s.push(numberString[i])
  }
  return s.reverse().join('', '')
}

export const getDateString = (date) => {
  let dateInfo = date.split('-')
  let year = dateInfo[0].substring(2, 4)
  let month = Number(dateInfo[1])
  if (month === 1) {
    month = 'Q1'
  } else if (month === 4) {
    month = 'Q2'
  } else if (month === 7) {
    month = 'Q3'
  } else if (month === 10) {
    month = 'Q4'
  }
  return month + year
}

/**
 * recursively flattens an array
 * @param {[]} arr
 * @returns {[]} arr
 */
export const flatten = arr => [].concat(...arr.map(v => (Array.isArray(v) ? flatten(v) : v)))

export const guid = function () {
  const s4 = function () {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4()
}

function fallbackCopyTextToClipboard (text) {
  const textArea = document.createElement('textarea')
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    const successful = document.execCommand('copy')
    const msg = successful ? 'successful' : 'unsuccessful'
    console.log('Fallback: Copying text command was', msg)
  } catch (err) {
    console.error('Fallback: Unable to copy:', err)
  }

  document.body.removeChild(textArea)
}

export function copyTextToClipboard (text) {
  if (!navigator.clipboard) {
    fallbackCopyTextToClipboard(text)
    return
  }
  navigator.clipboard.writeText(text)
    .then(function () {
      console.log('Copying to clipboard was successful!')
    }).catch(function (err) {
      console.error('Could not copy text:', err)
    })
}



// WEBPACK FOOTER //
// ./src/app/helpers/index.js